import React, { memo } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { Dropdown } from '@components';

const PageSize = ({ handlePagSize, selectedPageSize }) => {
  const { t } = useTranslation();
  const sizes = [10, 20, 30, 40, 50];

  return (
    <Box display="flex" alignItems="center">
      <Typography style={{ marginRight: 2 }}>{t('show')}</Typography>
      <Dropdown
        items={sizes}
        onChange={handlePagSize}
        selectedValue={selectedPageSize}
      />
    </Box>
  );
};

PageSize.propTypes = {
  handlePagSize: PropTypes.func.isRequired,
  selectedPageSize: PropTypes.number.isRequired,
};

export default memo(PageSize);
